export default "__VITE_ASSET__127ade36__"